import React from 'react';
import humanize from 'utils/humanize';

const ControlledInput = ({ name, type, value, onChange, disabled }) => (
  <input
    name={name}
    id={name}
    className="form-control"
    type={type}
    value={value}
    onChange={onChange}
    placeholder={humanize(name)}
    disabled={disabled}
  />
);

export default ControlledInput;
